module.exports = __webpack_public_path__ + "static/media/ELK.9fb596ae.png";